import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "snackbar-div" }
const _hoisted_2 = { class: "login-div" }
const _hoisted_3 = { class: "google-button-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "medium-text-white" }, "Or", -1)
const _hoisted_5 = { class: "input-field-container" }
const _hoisted_6 = { class: "input-field-container password-input-field" }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "login-button-container" }
const _hoisted_9 = { class: "forgot-password-div" }
const _hoisted_10 = {
  class: "medium-text-white forgot-password-link",
  href: ""
}
const _hoisted_11 = { class: "pre-registration-div" }
const _hoisted_12 = { class: "medium-text-white" }
const _hoisted_13 = { class: "registration-button-container" }
const _hoisted_14 = { class: "small-text-orange" }
const _hoisted_15 = { class: "small-text-white" }
const _hoisted_16 = { class: "small-text-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_snackbar = _resolveComponent("snackbar")!
  const _component_leftBlock = _resolveComponent("leftBlock")!
  const _component_ta_button = _resolveComponent("ta-button")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_rightBlock = _resolveComponent("rightBlock")!
  const _component_main_block = _resolveComponent("main-block")!
  const _component_main_footer = _resolveComponent("main-footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_snackbar, {
        buttonActionText: _ctx.buttonActionText,
        text: _ctx.snackbarMessage,
        show: _ctx.showSnackbar,
        onCloseSnackBar: _ctx.closeSnackBar
      }, null, 8, ["buttonActionText", "text", "show", "onCloseSnackBar"])
    ]),
    _createVNode(_component_main_block, { customClass: 'main-block-login' }, {
      default: _withCtx(() => [
        _createVNode(_component_leftBlock, {
          text: _ctx.welcomeMessage,
          imageSrc: ""
        }, null, 8, ["text"]),
        _createVNode(_component_rightBlock, { class: "signin-div" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_ta_button, {
                  text: _ctx.googleButtonText,
                  backgroundColor: _ctx.googleButtonBackgroundColor,
                  customClass: 'google-button',
                  showGoogleImage: "",
                  onClick: _ctx.loginWithGoogle
                }, null, 8, ["text", "backgroundColor", "onClick"])
              ]),
              _hoisted_4,
              _createVNode(_component_Form, { class: "form" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_input_field, {
                      onKeyup: _withKeys(_ctx.login, ["enter"]),
                      placeholder: _ctx.inputFieldEmailPlaceholder,
                      type: 'email',
                      errorMessage: _ctx.errorMessageEmail,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEmailErrorMessage(''))),
                      onInput: _ctx.receiveEmail,
                      onEmptyFieldEmail: _ctx.isInputFieldEmailEmpty,
                      onEmitEmail: _ctx.isEmailValid,
                      required: ""
                    }, null, 8, ["onKeyup", "placeholder", "errorMessage", "onInput", "onEmptyFieldEmail", "onEmitEmail"])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_input_field, {
                      onKeyup: _withKeys(_ctx.login, ["enter"]),
                      class: "small-text-grey",
                      placeholder: _ctx.inputFieldPasswordPlaceholder,
                      type: _ctx.passwordType,
                      errorMessage: _ctx.errorMessagePassword,
                      showPasswordIcon: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPasswordErrorMessage(''))),
                      onPasswordReveal: _ctx.showPassword,
                      onInput: _ctx.receivePassword,
                      onEmptyFieldPassword: _ctx.isInputFieldPasswordEmpty,
                      required: ""
                    }, null, 8, ["onKeyup", "placeholder", "type", "errorMessage", "onPasswordReveal", "onInput", "onEmptyFieldPassword"])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ta_button, {
                    text: _ctx.loginButtonText,
                    backgroundColor: _ctx.buttonBackgroundColor,
                    onClick: _ctx.login
                  }, null, 8, ["text", "backgroundColor", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_router_link, { to: "forgottenpassword" }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.forgotPasswordText), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.noAccountText), 1)
                ]),
                _createVNode(_component_router_link, { to: "registration" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_ta_button, {
                        class: "registration-button",
                        text: _ctx.registrationButtonText,
                        backgroundColor: _ctx.buttonBackgroundColor
                      }, null, 8, ["text", "backgroundColor"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("p", _hoisted_14, [
              _createTextVNode(_toDisplayString(_ctx.privacyPolicy) + " ", 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.and), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.termsOfService) + " ", 1),
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.apply), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_main_footer)
  ]))
}